import React, {
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';

export const FileListContext = createContext(
  {},
);

export const FileListProvider = ({ children }) => {
  const [listOptions, setListOptions] = useState({
    filterParams: {
      companies: undefined,
      presenter: undefined,
      requesterId: undefined,
      directorship: undefined,
      fileType: undefined,
      committe: undefined,
      startDate: null,
      endDate: null,
      keyword: '',
      showDeletedFiles: false,
    },
    selectedFolder: {
      formatted: '',
      searchPaths: [],
    },
  });

  const updateFilterParams = useCallback((params) => {
    setListOptions(oldValue => ({
      ...oldValue,
      filterParams: params
    }));
  }, []);

  const updateSelectedFolder = useCallback((folder) => {
    setListOptions(oldValue => ({
      ...oldValue,
      selectedFolder: folder
    }));
  }, []);

  return (
    <FileListContext.Provider
      value={{ listOptions, updateFilterParams, updateSelectedFolder }}
    >
      {children}
    </FileListContext.Provider>
  );
};

export function useFileList() {
  const context = useContext(FileListContext);

  if (!context) {
    throw new Error('useFileList must be used within an FileListProvider.');
  }

  return context;
}
